// extracted by mini-css-extract-plugin
module.exports = {"calendar":"InnerCalendar_calendar__2BRxY","calendar__light":"InnerCalendar_calendar__light__1dXAO","rotating":"InnerCalendar_rotating__1dKAr"};